export default __webpack_public_path__ + "static/kiiler-graphics-3f9934bce106ed0e8cadc5d69174199e.webp";